import React, { Component } from "react";
import { SideBar } from "../SIdeBar";
import { Header } from "../Header";
import commStyles from "../../styles";
import { connect } from "react-redux";
import { activeUser } from "../../../common/redux/actions";
import { ToastContainer } from "react-toastify";

const { PrimeMainContainer, SubMainContainer, MainWrapper, BoxWrapper } =
  commStyles;

class Container extends Component {
  state = {
    isSidebarExpanded: localStorage.getItem('sidebarExpanded') === 'true'
  };

  componentDidMount() {
    // Ensure sidebar state is synchronized on mount
    this.setState({ isSidebarExpanded: localStorage.getItem('sidebarExpanded') === 'true' });
  }

  handleSidebarToggle = (isExpanded) => {
    this.setState({ isSidebarExpanded: isExpanded });
    localStorage.setItem('sidebarExpanded', isExpanded);
  };

  render() {
    let propsState = this.props.state || {};
    let activeUser = propsState.activeUser || {};
    return (
      <React.Fragment>
        <PrimeMainContainer>
          <SideBar
            navPosition={
              typeof this.props.navPosition == "string"
                ? parseInt(this.props.navPosition)
                : this.props.navPosition
            }
            onToggle={this.handleSidebarToggle}
            isExpanded={this.state.isSidebarExpanded}
          />
          <Header headerName={this.props.headerName} activeUser={activeUser} />
          <SubMainContainer isExpanded={this.state.isSidebarExpanded}>
            <MainWrapper>
              <BoxWrapper>
                {this.props.children}
              </BoxWrapper>
              {/* Footer credit always at the bottom */}
              <div
                style={{
                  color: "rgba(68, 68, 68, 0.8)",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  fontWeight: 500,
                  fontSize: "10px",
                  margin: "8px 8px 4px 8px",
                }}
              >
                {``}
                <a
                  style={{ color: "rgba(68, 68, 68, 0.8)", textDecoration: "none" }}
                  href="https://www.linkedin.com/in/md-husain-thekiya/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Techstreat_Web_Solutions
                </a>
                &nbsp;{`©${new Date().getFullYear()} All Rights Reserved.`}
              </div>
            </MainWrapper>
          </SubMainContainer>
        </PrimeMainContainer>
        <ToastContainer
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, { activeUser })(Container);
